// The APP's own strings — page and feature text only: page and chart titles, tooltips, empty
// states, page-scoped namespaces (`headers.*`, `cards.*`, `tooltips.*`), file names, and the
// app-only drill-level `titleKey`s the chart configs pass to the base charts (raw keys; the
// base chart runs `t()` and resolves them through the root composer — SKILL.md rule 4).
// rdrive's shared words (nav and entity names, the item and document model, generic labels:
// `drawings`, `status`, `category`, `total`, …) are NOT here: they come from
// `@rdrive/vocabulary`, merged UNDER this bundle by `createDashboard` (@rdrive/plugin-dashboard-shell)
// as `mergeMessages(vocabulary, messages)` — both passed in `../dashboard.config.js`'s `i18n`
// (PLATFORM.md §6 decision 22).
// One home per key: never define a vocabulary key here — the app's copy would win silently;
// `pnpm i18n:extract` reports any such key under OVERRIDES. A packaged component's strings do
// NOT belong here either: they live in its own colocated `messages/` folder and are read with
// `useComponentI18n` from `@rdrive/i18n` (SKILL.md rule 11, PLATFORM.md §6 decision 15). Same
// format as those folders: one JSON per locale + this barrel.
//
// Adding a key means adding it to all 11 files (an untranslated key falls back to `en`
// through `fallbackLocale`). Adding a locale means `SUPPORTED_LOCALES` in `@rdrive/i18n` +
// a file here + a file in `@rdrive/vocabulary` + a file in every package `messages/` folder.
// `pnpm i18n:extract` reports the gaps for all of them (this bundle appears there as
// `project-overview/locales`, the vocabulary as `vocabulary`).
//
// JSON carries no comments, so the notes that used to sit inline in `locales.js` live here:
// - Keys in `en.json` are grouped by the page that renders them (App shell, TeamsPage,
//   DocumentsPage, then the charts); the other files keep roughly the same order.
// - `filterDialog.issues` / `filterDialog.processes` are the item-type LABELS for
//   `@rdrive/plugin-status-filter`'s `StatusFilterFab`: `App/setup.js` maps the item-type
//   keys to `{ key, label }` and passes them in through its `itemTypes` prop. The dialog's
//   own chrome lives in the package:
//   packages/rdrive-plugin-status-filter/src/components/StatusFilterFab/messages/
// - `subitem`, `singlestatus`, `profile`, `template`, `locations`, `users` are stacked-bar
//   drill-down level titles (`navigationConfig[].titleKey` in `charts/configs/`). The other
//   level titles (`drawingSets`, `teamProfile`, `teams`, `drawings`, `status`, `category`,
//   `subcategory`) are vocabulary keys: not in this bundle, resolved through the same root
//   composer from `@rdrive/vocabulary`.
// - `rdriveBurndownChart` / `rdriveVelocityChart` are PNG export FILE NAMES
//   (`ActivityPage`'s `exportFilename`, `.png` appended there), not UI text.
//
// Keep the imports plain: no `with { type: 'json' }` (Vite serves transformed JSON as
// JavaScript and the browser rejects the attribute). Node proof scripts need a `load` hook.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
